import React from 'react'
import { FormikProps, useFormikContext } from 'formik'
import { defaultNow } from '../../../../common/utils/dateTimeNow'
import { EulaSection } from '../../../../common/components/EulaSection/EulaSection'
import { EulaType } from '../../../../modules/privateOffer/types'
import {
  RadioButtonGroupMapping,
  RadioButtonType,
} from '@labrav/react-components'
import { microsoftStandardEula } from '../../../../common/utils/constants'
import {
  MicrosoftFormFAQs,
  MicrosoftFormFAQsItem,
} from '../MicrosoftFormFAQs/MicrosoftFormFAQs'

export const Eula = ({
  setEulaErr,
  eulaErr,
  showEulaOptions = true,
  disableEulaFileUpload = false,
  showEulaFileUpload = true,
  disableEulaOptions = false,
}: {
  eulaErr: string
  setEulaErr: React.Dispatch<React.SetStateAction<string>>
  showEulaOptions?: boolean
  disableEulaFileUpload?: boolean
  showEulaFileUpload?: boolean
  disableEulaOptions?: boolean
}) => {
  const formikValues = useFormikContext() as FormikProps<
    Record<string, unknown>
  >

  const eulaButtonOptionsV2: RadioButtonGroupMapping[] = [
    {
      key: EulaType.PUBLIC,
      label: 'Public offer legal terms',
      type: RadioButtonType.STANDARD,
      url: microsoftStandardEula,
    },
    {
      key: EulaType.STANDARD,
      label: 'Standard Contract for Microsoft Marketplace',
      type: RadioButtonType.STANDARD,
      infoDescription:
        'Use standardized contract template intended to help streamline procurement and speed up transactions.',
      url: microsoftStandardEula,
    },
    {
      key: EulaType.CUSTOM,
      label: 'Custom EULA',
      type: RadioButtonType.STANDARD,
    },
  ]

  const updateErr = (error: string) => {
    setEulaErr(error)
  }
  return (
    <div id={'eulaFiles'}>
      <EulaSection
        defaultNow={defaultNow}
        formik={formikValues as unknown as FormikProps<Record<string, unknown>>}
        isMultiFileUpload={true}
        fileUploadDescription={
          'Upload up to 5 plain text (.txt) or PDF files (max 10 MB each) to amend the Microsoft marketplace Standard Contract. Files will be combined into one PDF in upload order and shown to buyers.'
        }
        fileUploadButtonText={'Upload'}
        fileUploadContainerTitle={
          'Upload a up to 5 PDF files. Drag and drop it below.'
        }
        quantity={5}
        eulaOptionsHeading={''}
        eulaOptions={eulaButtonOptionsV2}
        fileSize={10}
        updateErr={updateErr}
        uploadError={
          eulaErr ||
          (formikValues?.touched?.eulaFiles
            ? formikValues?.errors?.eulaFiles
            : '')
        }
        showEulaFileUpload={showEulaFileUpload}
        disableEulaFileUpload={disableEulaFileUpload}
        disableEulaOptions={disableEulaOptions}
        showEulaOptions={showEulaOptions}
        hideSubHeading
        eulaFilesKeyName={'eulaFiles'}
        acceptedFormats={['.pdf']}
        secondaryActions={
          <MicrosoftFormFAQs item={MicrosoftFormFAQsItem.EULA} />
        }
      />
    </div>
  )
}
